import { render, staticRenderFns } from "./PopUpBannersDetail.vue?vue&type=template&id=23e46e4a&scoped=true"
import script from "./PopUpBannersDetail.vue?vue&type=script&lang=js"
export * from "./PopUpBannersDetail.vue?vue&type=script&lang=js"
import style0 from "./PopUpBannersDetail.vue?vue&type=style&index=0&id=23e46e4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23e46e4a",
  null
  
)

export default component.exports